module.exports = __webpack_public_path__ + "media/images/add_teammate-1dafc2a6c005ed0516d7fbb816ee8181.svg";